import { FeatureFlagControl } from "@/Common/Components/FeatureFlagControl";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { IListCreateAndEditItemModel } from "@/Lists/Models/UI/IListCreateAndEditItemModel";
import { IListModel } from "../Models/UI/IListModel";
import { IListsTabModel } from "../Models/UI/IListsTabModel";
import { EmptyContent } from "./EmptyContent";
import { ListItems } from "./ListItems";
import { ListsTreeControl } from "./ListsTreeControl";
import { NewListsTab } from "./NewListsTab";

class ListsTabState {
    public Model: IListsTabModel;
    public ListModel: IListModel;
    public ListCreateAndEditItemModel: IListCreateAndEditItemModel;
}

class ListsTab extends React.Component<any, ListsTabState> {
    private changeListenerMethodId: string;

    constructor(props: any) {
        super(props);

        const initialState = new ListsTabState();
        initialState.Model = listsStore.ListsTabModel;
        initialState.ListModel = listsStore.ListModel;
        initialState.ListCreateAndEditItemModel = listsStore.ListCreateAndEditItemModel;
        this.state = initialState;
    }

    public render(): JSX.Element {
        var viewToReturn = <EmptyContent />;
        if (this.state.Model.get("IsAnyListSelected")) {
            viewToReturn = <ListItems Model={this.state.ListModel} CreateAndEditModel={this.state.ListCreateAndEditItemModel} />;
        }

        return (
            <FeatureFlagControl
                flag={cacheStore.ClinicSettings.EnableGroupAppointmentAndNote}
                activeFeature={(
                    <NewListsTab
                        model={this.state.Model}
                        listModel={this.state.ListModel}
                        listCreateAndEditItemModel={this.state.ListCreateAndEditItemModel}
                    />
                )}
                fallbackFeature={(
                    <div className="sub-container" onClick={e => e.stopPropagation()}>
                        <div className="left-nav-menu transition">
                            <div className="ws-scrollable hide-overflow">
                                <ListsTreeControl
                                    Model={this.state.Model.get("ClinicalWaitingLists")}
                                    ShowAddNewListPopup={this.state.Model.get("ShowAddNewListPopup")}
                                />
                            </div>
                        </div>
                        {true && viewToReturn}
                    </div>
                )}
            />
        );
    }

    public componentDidMount(): void {
        this.changeListenerMethodId = listsStore.AddChangeListener(this.changeListener, this, "list-tab-listener");

        window.setTimeout(
            () => {
                sessionStore.dispatch(LocalOperations.Lists.Store_Mounted);
            },
            50
        );
    }

    public componentWillUnmount(): void {
        listsStore.RemoveChangeListener(this.changeListenerMethodId);
    }

    public shouldComponentUpdate(nextProps: any, nextState: ListsTabState): boolean {
        return (
            this.state.Model !== nextState.Model
            || this.state.ListCreateAndEditItemModel !== nextState.ListCreateAndEditItemModel
            || this.state.ListModel !== nextState.ListModel
        );
    }

    public changeListener(): void {
        var s = new ListsTabState();
        s.Model = listsStore.ListsTabModel;
        s.ListModel = listsStore.ListModel;
        s.ListCreateAndEditItemModel = listsStore.ListCreateAndEditItemModel;

        this.setState(s);
    }
}

export { ListsTab };
